import React, { useState, useRef } from 'react';
import { BundleCardSimple, BundleCardMerged } from './';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Navigation, Scrollbar } from 'swiper';

// Styles must use direct files imports
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/scrollbar/scrollbar.scss';



export const BundleStep = ({ step }) => {

  const [init, setInit] = useState(false);

  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)
  return (
    <div className="Section Section--bundle-step">
      <div className='Container'>
        <div className='Section__header'>
          <h2>{step.heading}</h2>
        </div>
        <div className='Section__content'>
          <Swiper
            observer={true}
            observeParents={true}
            slidesPerView={1.2}
            modules={[Navigation, Scrollbar]}
            navigation={{
              prevEl: navigationPrevRef.current,
              nextEl: navigationNextRef.current
            }}
            onBeforeInit={(swiper) => {
              setInit(true)
            }}
            scrollbar={{ draggable: true }}
            spaceBetween={16}
            centerInsufficientSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
              1024: {
                spaceBetween: 32,
                slidesPerView: 5,
              },
            }}
          >
            {step.items.map(i => {
              if (i.collection) {
                if (i.collection.products.length > 0) {
                  return <SwiperSlide key={i.collection.handle}><BundleCardMerged object={i.collection} /></SwiperSlide>
                }
              } else {
                return <SwiperSlide key={i.product.handle} ><BundleCardSimple object={i.product} /></SwiperSlide>
              }
            })
            }

          </Swiper>
          <button type="button" className='Button Button--noLayout swiper-nav swiper-nav-prev' ref={navigationPrevRef}>
            <span className="u-hidden">Prev</span>
          </button>
          <button type="button" className='Button Button--noLayout swiper-nav swiper-nav-next' ref={navigationNextRef}>
            <span className="u-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  )
}
